import React from 'react';
import { render } from 'react-dom';
import Constructor from './Constructor';

render(<Constructor />, document.getElementById('app'));




/** WEBPACK FOOTER **
 ** ./frontend/index.js
 **/